<div *ngIf="isDBUpgrading" class="db-upgrading-screen">
  <div class="db-upgrading-content">
    <mat-spinner></mat-spinner>
    <h2>Actualizando base de datos local...</h2>
    <p>Por favor espera unos segundos mientras se actualiza la base de datos.</p>
  </div>
</div>
<router-outlet *ngIf="loadedApp() && !isDBUpgrading"></router-outlet>
<app-loader [error]="error()" *ngIf="!loadedApp()"></app-loader>
